import { React, useEffect, useState } from "react"
import { Button, Card, Col, Row } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";

import "../../assets/stlyes/SuperAdmin/SuperAdmin.scss";

import { SuperAdminTable, AddSchoolModal, styles } from "./";
import { Header, LoadingSpinner } from "../Shared";
import * as superAdminApi from "../../api/superAdminApi";
import { Common } from "../../helper";
import { isEmptyObject } from "../../util";
import { setSelect } from "../../store/stylesSlice";

const SuperAdmin = () => {
  const isNavCollapsed = useSelector((state) => state.styleData.isNavCollapsed)
  const dispatch = useDispatch();
  const [allSchoolData, setAllSchoolData] = useState({});
  const [showModal, setShowModal] = useState()
  const [isLoading, setIsLoading] = useState(false)

  const setFullScreen = () => {
    return (!isNavCollapsed ? "170px" : "10px")
  }

  const getSchoolDetails = async () => {
    setIsLoading(true)
    const allSchools = await superAdminApi.getAllSchools();
    if (!isEmptyObject(allSchools.Items)) {
      setAllSchoolData(allSchools.Items);
    }
    else {
      setAllSchoolData({})
    }
    setIsLoading(false)
  }

  const OpenAddSchoolModal = () => { setShowModal(true) }

  useEffect(() => {
    getSchoolDetails()
    dispatch(setSelect("Dashboard"));
  }, [])

  return (
    <div className="Page-layout">
      <div className="Page-header">
        <Header />
        {isLoading ? <LoadingSpinner /> : <div style={{ marginTop: "50px" }}>
          <Card className="d-flex superAdminDashBoardMain" >
            {allSchoolData && <div className="displayCountMainSuperAdmin">
              <div className="d-flex justify-content-center align-items-center flex-column ActiveCountDiv"><span className="pupilTitle">Total Schools</span><span className="pupilCount">{!isEmptyObject(allSchoolData) ? allSchoolData.totalSchools : 0}</span></div>
              <div className="d-flex justify-content-center align-items-center flex-column DisabledCountDiv" ><span className="teacherTitle">Active Schools</span><span className="teacherCount">{!isEmptyObject(allSchoolData) ? allSchoolData.activeSchools : 0}</span></div>
            </div>}
          </Card>
          {!isEmptyObject(allSchoolData) ? <SuperAdminTable setFullScreen={setFullScreen} allSchoolData={allSchoolData} getSchoolDetails={getSchoolDetails} /> :
            <>
              <Row className="mb-3">
                <Col xs={3}>
                  <div style={styles.addButton}>
                    <Button style={{ background: "#084059", borderRadius: "25px", width: "150px", color: "white", zIndex: "1" }} onClick={OpenAddSchoolModal} >{"Add School"}</Button>
                    <AddSchoolModal showModal={showModal} setShowModal={setShowModal} isEdit={false} formValues={""}getSchoolDetails={getSchoolDetails} />
                  </div>
                </Col>
                <Col xs={8}></Col>
                <div className="d-flex justify-content-center">
                  <h1>{Common.NoSchoolFound}</h1>
                </div>
              </Row>
            </>}
        </div>}
      </div>
    </div>
  )
}

export { SuperAdmin };
